import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var InterviewBankRoutes = {
    "/interview-bank/questions-list": {
        "loginRequired": true,
        "name": "appLayout.harriSH.interview-questions-bank",
        "type": "frontend",
        "component": "interviewQuestionsBankController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                brandServices
                    .checkAll(hUser.getActiveBrandIdWithAccess(),[
                        brandServices.SERVICES.QUESTION_BANK,
                        brandServices.SERVICES.ONBOARDING_JOURNEY,
                    ])
                    .then(function (services) {
                        var isQuestionBankEnabled = services[brandServices.SERVICES.QUESTION_BANK];
                        var isOnBoardingJourneyEnabled = services[brandServices.SERVICES.ONBOARDING_JOURNEY];
                        if (!isQuestionBankEnabled || isOnBoardingJourneyEnabled) {
                            if(hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        }
                    });
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
            }]
    },
    "/interview-bank/templates-list": {
        "loginRequired": true,
        "name": "appLayout.harriSH.interview-questions-templates",
        "type": "frontend",
        "component": "interviewQuestionsTemplatesController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                brandServices
                    .check(brandServices.SERVICES.QUESTION_BANK, hUser.getActiveBrandIdWithAccess())
                    .then(function (isQuestionBankEnabled) {
                        if (!isQuestionBankEnabled) {
                            if(hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        }
                    });
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
            }]
    },
    "/interview-bank/questions/{questionId:[0-9]*}": {
        "loginRequired": true,
        "name": "appLayout.harriSH.interview-question",
        "params": {"questionId": ""},
        "type": "frontend",
        "component": "interviewQuestionController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                brandServices
                    .check(brandServices.SERVICES.QUESTION_BANK, hUser.getActiveBrandIdWithAccess())
                    .then(function (isQuestionBankEnabled) {
                        if (!isQuestionBankEnabled) {
                            if(hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        }
                    });
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
            }]
    },
    "/interview-bank/templates/{templateId:[0-9]*}": {
        "loginRequired": true,
        "name": "appLayout.harriSH.interview-template",
        "params": {"templateId": ""},
        "type": "frontend",
        "component": "interviewTemplateController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                brandServices
                    .check(brandServices.SERVICES.QUESTION_BANK, hUser.getActiveBrandIdWithAccess())
                    .then(function (isQuestionBankEnabled) {
                        if (!isQuestionBankEnabled) {
                            if(hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        }
                    });
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
            }]
    },
    "/interview-bank/job/{jobId:[0-9]*}/app/{applicationId:[0-9]*}/results/{evaluationType:PHONE|JOB|JOB_SECOND_INTERVIEW}": {
        "loginRequired": true,
        "name": "appLayout.harriSH.interview-results",
        "params": {evaluationType: ""},
        "type": "frontend",
        "reloadOnSearch": false,
        "component": "interviewResultsController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../modules/ams/ams.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                brandServices
                    .check(brandServices.SERVICES.QUESTION_BANK, hUser.getActiveBrandIdWithAccess())
                    .then(function (isQuestionBankEnabled) {
                        if (!isQuestionBankEnabled) {
                            if(hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        }
                    });
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
            }]
    },
    "/interview-bank/job/{jobId:[0-9]*}/app/{applicationId:[0-9]*}/evaluation/{evaluationId:[0-9]*}?jobBrandId": {
        "loginRequired": true,
        "name": "appLayout.harriSH.interview-answers",
        "params": {evaluationId: ""},
        "type": "frontend",
        "reloadOnSearch": false,
        "component": "interviewAnswersController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../modules/ams/ams.module.js");
                }
            }
        ],
        "resolve": {
            switchActiveBrand: ['$stateParams', 'hUser', async ($stateParams, hUser) => {
                const activeBrandId = hUser.getActiveBrandIdWithAccess();
                const jobBrandId = parseInt($stateParams.jobBrandId);

                if (jobBrandId && jobBrandId !== activeBrandId) {
                    const brandInfo = await BrandAPI.getBrandBasicInfo(jobBrandId);

                    await hUser.setUserContext({
                        brand_id: brandInfo.group_id,
                        brand_type: `enterprise`,
                        active_brand_id: jobBrandId,
                        active_brand_type: brandInfo.type
                    });
                }

                return true;
            }]
        },
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                brandServices
                    .check(brandServices.SERVICES.QUESTION_BANK, hUser.getActiveBrandIdWithAccess())
                    .then(function (isQuestionBankEnabled) {
                        if (!isQuestionBankEnabled) {
                            if(hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        }
                    });
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
            }]
    },
    "/interview-bank/types": {
        "loginRequired": true,
        "name": "appLayout.harriSH.interview-questions-types",
        "type": "frontend",
        "component": "questionsBankTypesController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'hUser',
            function ($state, $stateParams, brandServices, interviewBankDataService, hUser) {
                brandServices
                    .check(brandServices.SERVICES.QUESTION_BANK, hUser.getActiveBrandIdWithAccess())
                    .then(function (isQuestionBankEnabled) {
                        if (!isQuestionBankEnabled) {
                            if(hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        }
                    });
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
            }]
    },

    [`/interview-bank/questions-list/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-questions-bank",
        "type": "frontend",
        "component": "interviewQuestionsBankController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "params": {
            ...hmapPathParamConfig
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService, useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
    [`/interview-bank/templates-list/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-questions-templates",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "component": "interviewQuestionsTemplatesController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService, useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
    [`/interview-bank/questions/new/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-question-new",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "component": "interviewQuestionController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService,useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
    [`/interview-bank/questions/{questionId:[0-9]*}/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-question-edit",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "component": "interviewQuestionController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService,useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            $state.go('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
    [`/interview-bank/templates/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-template-new",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "component": "interviewTemplateController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService, useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            $state.go('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
    [`/interview-bank/templates/{templateId:[0-9]*}/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-template-edit",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "component": "interviewTemplateController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService, useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
    [`/interview-bank/job/{jobId:[0-9]*}/app/{applicationId:[0-9]*}/results/{evaluationType:PHONE|JOB|JOB_SECOND_INTERVIEW}/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-results",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "reloadOnSearch": false,
        "component": "interviewResultsController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../modules/ams/ams.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService, useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
    [`/interview-bank/job/{jobId:[0-9]*}/app/{applicationId:[0-9]*}/evaluation/{evaluationId:[0-9]*}/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-answers",
        "params": {...hmapPathParamConfig},
        "type": "frontend",
        "reloadOnSearch": false,
        "component": "interviewAnswersController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../modules/ams/ams.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService, useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
    [`/interview-bank/types/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "name": "appLayout.harriSH.access-portal.interview-questions-types",
        "type": "frontend",
        "params":{
            ...hmapPathParamConfig
        },
        "component": "questionsBankTypesController",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_bank", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Question Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-bank.module.js");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'interviewBankDataService', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, brandServices, interviewBankDataService, navigationService, useGPSettingsNav) {
                interviewBankDataService.setServiceType(interviewBankDataService.SERVICE_TYPES.QUESTION_BANK);
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.interview-questions-bank', {hmapPath: $stateParams['hmapPath']}))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }]
    },
};